import "./index.css";
import { QRCodeGenerator } from "@/components/QRCodeGenerator";

export function App() {
  return <QRCodeGenerator />;
}

export default App;
